export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then(() => {
          console.log('Service Worker registered');
        })
        .catch(err => {
          console.error('Service Worker failed:', err);
        });
    });
  }
}
